<div class="tab-wrapper">
    <div
        class="tab"
        [ngClass]="{
            disabled: isDisabled,
            'horizontal-active': isActive && mode === 'horizontal',
            'vertical-active': isActive && mode === 'vertical',
            'reorder-mode': isReorderMode
        }"
        [class.horizontal]="mode === 'horizontal'"
        [class.active]="isActive"
        [class.vertical]="mode === 'vertical'"
    >
        <div class="flex align-items-center">
            <mat-icon
                *ngIf="icon != ''"
                class="position-svg black margin-right-xs"
                [class.margin-right-sm]="mode === 'vertical'"
                [class.position-relative]="mode === 'vertical'"
                [class.position]="mode === 'vertical'"
                [class.blue]="isReorderMode"
                >{{ icon }}</mat-icon
            >
            {{ label }}
        </div>
        <ng-content></ng-content>
    </div>
</div>

